// utils
import axios from "src/utils/axios";
import apiSlice from "src/utils/api-slice";

// ----------------------------------------------------------------------

const API_ENDPOINTS = {
    getCarriers: "/carrier/query_all",
    getCarrier: "/carrier/query_by_id",
    editCarrier: "/carrier/edit",
    //
    activateCarrier: "/carrier/activate",
    //
    checkProviderAgreement: "/carrier/is_agree_fixed_agreement",
    //
    checkUPSAgreement: "/carrier/is_agree_ups_agreement",
    confirmUPSAgreement: "/carrier/accept_ups_agreement",
    //
    confirmUPSCanadaAgreement: "/carrier/accept_ups_canada_agreement",
    //
    checkFedexAgreement: "/carrier/is_agree_fedex_agreement",
    confirmFedexAgreement: "/carrier/accept_fedex_agreement"
};

// ----------------------------------------------------------------------

const checkProviderAgreement = (code) => axios.get(`${API_ENDPOINTS.checkProviderAgreement}`, {
    params: {
        provider_id: code
    }
});

const checkUPSAgreement = () => axios.get(`${API_ENDPOINTS.checkUPSAgreement}`);

const confirmUPSAgreement = (request, fingerprint) => axios.post(`${API_ENDPOINTS.confirmUPSAgreement}`, {...request}, {
    headers: {
        "X-Fingerprint-Request-Id": fingerprint?.event_id ?? "",
    },
});

const confirmUPSCanadaAgreement = (request, fingerprint) => axios.post(`${API_ENDPOINTS.confirmUPSCanadaAgreement}`, {...request}, {
    headers: {
        "X-Fingerprint-Request-Id": fingerprint?.event_id ?? "",
    },
});

const checkFedexAgreement = () => axios.get(`${API_ENDPOINTS.checkFedexAgreement}`);

const confirmFedexAgreement = () => axios.post(`${API_ENDPOINTS.confirmFedexAgreement}`);

// ----------------------------------------------------------------------

const {
    useGetCarrierListQuery,
    //
    useLazyGetCarrierQuery,
    useUpdateCarrierMutation,
    //
    useActivateCarrierMutation
} = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCarrierList: builder.query({
            keepUnusedDataFor: 5,
            providesTags: ["CarrierList"],
            query: () => `${API_ENDPOINTS.getCarriers}`,
            transformResponse: ({data}, meta, arg) => data
        }),
        getCarrier: builder.query({
            query: ({id}) => ({
                url: `${API_ENDPOINTS.getCarrier}`,
                params: {
                    account_id: id
                }
            }),
            transformResponse: ({data}, meta, arg) => data
        }),
        updateCarrier: builder.mutation({
            query: (carrier) => ({
                url: `${API_ENDPOINTS.editCarrier}`,
                method: "POST",
                body: carrier
            }),
            transformResponse: ({data}, meta, arg) => data,
            invalidatesTags: ["CarrierList"] // 触发数据更新
        }),
        activateCarrier: builder.mutation({
            query: (request) => ({
                url: `${API_ENDPOINTS.activateCarrier}`,
                method: "POST",
                body: request
            }),
            transformResponse: ({data}, meta, arg) => data,
            invalidatesTags: ["CarrierList"] // 触发数据更新
        })
    }),
    overrideExisting: true
});

// ----------------------------------------------------------------------

export {
    checkProviderAgreement as checkProviderAgreementAPI,
    //
    checkUPSAgreement as checkUPSAgreementAPI,
    confirmUPSAgreement as confirmUPSAgreementAPI,
    //
    confirmUPSCanadaAgreement as confirmUPSCanadaAgreementAPI,
    //
    checkFedexAgreement as checkFedexAgreementAPI,
    confirmFedexAgreement as confirmFedexAgreementAPI,
    //
    useGetCarrierListQuery,
    //
    useLazyGetCarrierQuery,
    useUpdateCarrierMutation,
    //
    useActivateCarrierMutation
};
